module.exports = {
  generateHeaderMenuLinks(arr) {
    return arr.map((link) => `<a href="${link.href}">${link.label}</a>`).join('');
  },
};



// WEBPACK FOOTER //
// ./scriptPartials/helperFunctions.js